"use strict";
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class
 * @implements AuthenticationProviderOptions
 * Class representing MSALAuthenticationProviderOptions
 */
var MSALAuthenticationProviderOptions = /** @class */ (function () {
    /**
     * @public
     * @constructor
     * To create an instance of MSALAuthenticationProviderOptions
     * @param {string[]} scopes - An array of scopes
     * @returns An instance of MSALAuthenticationProviderOptions
     */
    function MSALAuthenticationProviderOptions(scopes) {
        this.scopes = scopes;
    }
    return MSALAuthenticationProviderOptions;
}());
exports.MSALAuthenticationProviderOptions = MSALAuthenticationProviderOptions;
//# sourceMappingURL=MSALAuthenticationProviderOptions.js.map